
















  import AbpBase from "@/lib/abpbase";
  import { Component, Prop } from "vue-property-decorator";
  import  { QueryPatientThresholdList,PushPatientThresholdList} from "@/api/pdOutPatient/pdBasicInformation"

  
  @Component({
    components: { },
  })
  export default class extends AbpBase { 
    @Prop() data: any;
    @Prop() value: boolean;
    loading = false;
    totalCount = 0;
    payload = {
    QueryString: "",
    itemCode:"",
    Page: 1,
    PageSize: 10
  };
  patient=[];
  column= [
    {
			key: 'name',
			title: '患者姓名'
		},
    {
			key: 'sex',
			title: '性别'
		},
    {
			key: 'age',
			title: '年龄'
		},
		{
			key: 'threshold',
			title: '是否设置个人阈值',
      render:(h:any, p:any)=>{
        return h('span',{style:{color: p.row.threshold ? 'red' : ''}}, p.row.threshold ? '已设置' : '未设置')}
		},
    {	
      key: 'lastPushTime',
			title: '上次推送时间',
      minWidth: 140,
      render:(h:any, p:any)=>{
					return h('span', this.formatDateTime(p.row.lastPushTime))
				}
    },
    {
      key: '',
			title: '操作',
      render:(h:any, p:any)=>{
				return h('div', [
        h('Button',{
						props:{type: 'info'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.push(p.row)
							}
						}
					},'推送'),
				],)}
    }
  ]
  pushList={
    id:null,
    threshold:[],
   }
    cancel() {
    this.$emit("input", false);
   }
     async save() {
      this.$emit('save-success')
    }
  query() {
    this.getData();
  }
  async push(row:any){
    console.log(row);
    this.pushList.id=row.id
    this.data.model.forEach((item:any) => {
    this.pushList.threshold.push(item.id);
    });
    if(row.threshold){
      var content="";
      if((new Date(row.lastPushTime).getFullYear()+new Date(row.lastPushTime).getMonth()+new Date(row.lastPushTime).getDay())==(new Date().getFullYear()+new Date().getMonth()+new Date().getDay())){
         content='今天已推送一次，是否再次推送'
      }else{
       content=this.formatDate(row.lastPushTime)+'已推送一次，是否再次推送'
      }
      this.$Modal.confirm({
			title: '推送确认界面',
			content:content ,
      	onOk: async () => {
        await PushPatientThresholdList(this.pushList);
        this.pushList.threshold=[];
        this.query();
			},
			onCancel: () => {	}
		})
    }else{
    let res =  await PushPatientThresholdList(this.pushList);
    this.pushList.threshold=[];
    this.query();
  }
  }
  created(){
    console.log(this.data)
    this.getData();
  }
 async getData(){
    this.loading = true;
    this.payload.itemCode= this.data.itemcode;
    let res = await QueryPatientThresholdList(this.payload);
    this.patient = res.items;
    this.totalCount = res.totalCount;
    this.loading = false;

  }
  handlePageChange(val: any) {
    this.payload.Page = val;
    this.query();
  }
    visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

      
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/publicThreshold/patientpush.vue